import Icon from '../components/Icon.vue'

Icon.register({"highlighter":{"width":544,"height":512,"paths":[{"d":"M0 480L99.9 512 135.4 476.6 68.3 409.5 0 480zM124.6 240A36.6-36.6 0 0 1 113.8 278.1L126.9 320.9 75.9 371.8 172.2 468.1 223 417.2 265.8 430.3C279.5 434.5 294.4 430.3 303.9 419.5L339.5 377.9 166.1 204.5 124.6 240zM527.9 79.3L464.7 16.1C444.2-4.4 411.3-5.4 389.6 13.7L190.6 183.7 360.3 353.5 530.3 154.4C549.4 132.7 548.4 99.8 527.9 79.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/highlighter.js
// module id = null
// module chunks = 